// Sometimes we want paths to be accessible to both signed in and not signed in users.
export const SHARED_DESTINATIONS = ["documents", "forms", "video"];
export const SHARED_PATHS = SHARED_DESTINATIONS.map((path) => `/${path}`);
